module.exports = __webpack_public_path__ + "assets/img/b4-2.cff8fbd0.png";